<div class="object-lookup">
  <!-- show input only while searching -->
  <mat-form-field *ngIf="isSearching" appearance="outline" class="full-width">
    <mat-label>{{label}}</mat-label>
    <input matInput
           [(ngModel)]="searchTerm"
           (ngModelChange)="onSearch($event)"
           placeholder="Search"
           autocomplete="off" />
  </mat-form-field>

  <!-- selected item view: show label like mat-label and the details -->
  <div *ngIf="selectedObject && !isSearching" class="selected-wrapper">
    <div class="selected-label">{{ label }}</div>
    <div class="selected-object-details" (click)="enterSearchMode()">
      <ng-container *ngTemplateOutlet="itemTemplate; context:{ item: selectedObject }"></ng-container>
    </div>
  </div>

  <!-- no selection view: show label and a search trigger -->
  <div *ngIf="!selectedObject && !isSearching" class="no-selection">
    <div class="selected-label">{{ label }}</div>
    <div class="no-selection-controls">
      <button mat-stroked-button color="primary" (click)="enterSearchMode()">Search</button>
    </div>
  </div>

  <div class="results" *ngIf="isSearching && searchResults?.length">
    <div class="result-item"
         *ngFor="let item of searchResults"
         [class.selected]="getObjectId(item) === getObjectId(selectedObject)"
         (click)="selectObject(item)">
      <ng-container *ngTemplateOutlet="itemTemplate; context: { item: item }"></ng-container>
    </div>
  </div>
</div>

<ng-template #itemTemplate let-item="item">
  <div class="detail-line">
    <strong class="detail-name">{{ getObjectName(item) }}</strong>
    <span class="detail-id">ID: {{ getObjectId(item) }}</span>
  </div>
  <div class="detail-specs" *ngIf="item">
    <span *ngIf="item.Preference">Preference: {{ item.Preference }}</span>
    <span *ngIf="item.Country">Country: {{ item.Country }}</span>
    <span *ngIf="item.Currency">Currency: {{ item.Currency }}</span>
    <span *ngIf="item.MinDiscount !== undefined">Min Discount: {{ item.MinDiscount }}%</span>
    <span *ngIf="item.Distributor">Distributor: {{ item.Distributor?.Name || item.Distributor }}</span>
  </div>
</ng-template>
